import MetaInfoList from "components/MetaInfoList";
import TimestampMetaInfo from "components/Timestamp/MetaInfo";
import ViewHeader from "components/ViewHeader";
import ViewHeaderScrollCollapse from "components/ViewHeader/ScrollCollapse";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import ScanRunStateBadge from "shared/Scan/StateBadge";

import { getScanRunTitle } from "../../helpers";
import { ScanRunDetailItem } from "../../types";

const noop = () => undefined;

type ScanRunHeaderProps = {
  run: ScanRunDetailItem;
};

const ScanRunHeader = ({ run }: ScanRunHeaderProps) => (
  <ViewHeader>
    <ViewHeaderWrapper direction="row" justify="between" fullWidth>
      <ViewHeaderWrapper direction="row" align="center">
        <ViewHeaderTitle>{getScanRunTitle(run.createdAt)}</ViewHeaderTitle>
        <ScanRunStateBadge state={run.state} />
      </ViewHeaderWrapper>

      <ViewHeaderWrapper direction="row" align="end" shrink="0">
        <DropdownMenuEllipsis dotsSize="medium" tooltip="Scan run actions">
          <DropdownMenuItem onAction={noop}>Details</DropdownMenuItem>
        </DropdownMenuEllipsis>
      </ViewHeaderWrapper>
    </ViewHeaderWrapper>

    <ViewHeaderScrollCollapse>
      <MetaInfoList>
        <TimestampMetaInfo prefix="Updated" timestamp={run.stateChangedAt} />
      </MetaInfoList>
    </ViewHeaderScrollCollapse>
  </ViewHeader>
);

export default ScanRunHeader;
